import { Collection } from 'modules/core/lib/mobx-rest'

import Visit from 'modules/posts/store/models/Visit'

class Visits extends Collection<Visit> {
  get cacheKey(): string {
    return 'visits'
  }

  model() {
    return Visit
  }
}

const singleton: Visits = new Visits()

export default singleton
